import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SalesLanding from "@/pages/SalesLanding";
import FlyerEditor from "@/pages/FlyerEditor";
import AdvertStudio from "@/pages/AdvertStudio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SalesLanding />} />
          <Route path="/advert" element={<AdvertStudio />} />
          <Route path="/studio" element={<FlyerEditor />} />
          {/* Legacy multi-page site has been retired — everything points home. */}
          <Route path="/site" element={<Navigate to="/" replace />} />
          <Route path="/owners" element={<Navigate to="/" replace />} />
          <Route path="/hosts" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#114232",
            color: "#FAF7F1",
            border: "1px solid #94A596",
          },
        }}
      />
    </div>
  );
}

export default App;
